import { Directive, ElementRef, AfterContentInit } from '@angular/core';
import { CompatibilityService } from '../compatibility.service';

@Directive({
  selector: 'input[appAutoFocus]'
})
export class AutofocusDirective implements AfterContentInit {

  constructor(
    private el: ElementRef<HTMLInputElement>,
    private compatibilityService: CompatibilityService
  ) { }

  ngAfterContentInit() {
    // Note: focus if hover supported (i.e., prevents auto keyboard popup on touch only devices)
    const isHoverSupported = this.compatibilityService.isHoverSupported();

    if (isHoverSupported) {
      setTimeout(() => {
        this.el.nativeElement.focus();
      }, 0);
    }
  }
}
